import { type PortalMember } from "@/hooks/useUsers";
import { Button } from "@simplicity/ui";
import { UserPlus, X } from "lucide-react";

export function GroupMembersList({
  members,
  emailMap,
  onRemoveMember,
  onOpenAddMember,
}: {
  members: { id: string; userId: string; email: string }[];
  emailMap: Map<string, PortalMember>;
  onRemoveMember: (userId: string) => void;
  onOpenAddMember: () => void;
}) {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- intentional: empty-string name falls through to email
  const displayName = (u: PortalMember) => u.name || u.email;

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-xs font-semibold text-muted-foreground">Members</h4>
        <Button variant="link" size="sm" onClick={onOpenAddMember}>
          <UserPlus className="h-3.5 w-3.5" /> Add Member
        </Button>
      </div>
      {members.length === 0 ? (
        <p className="text-xs text-muted-foreground">No members yet.</p>
      ) : (
        <div className="flex flex-wrap gap-2">
          {members.map((m) => {
            const mu = emailMap.get(m.userId);
            const label = mu ? displayName(mu) : m.email;
            return (
              <span
                key={m.id}
                className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-muted text-xs"
              >
                {label}
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-4 w-4 hover:text-destructive hover:bg-transparent"
                  onClick={() => onRemoveMember(m.userId)}
                  aria-label="Remove member"
                >
                  <X className="h-3 w-3" />
                </Button>
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
}
